export { default as LineSkeleton } from './LineSkeleton';
export type { LineSkeletonProps } from './LineSkeleton';
export { default as ParagraphSkeleton } from './ParagraphSkeleton';
export type { ParagraphSkeletonProps } from './ParagraphSkeleton';
export { default as RectangleSkeleton } from './RectangleSkeleton';
export type { RectangleSkeletonProps } from './RectangleSkeleton';
